import { render, staticRenderFns } from "./CopyFoodcard.vue?vue&type=template&id=46090b24"
import script from "./CopyFoodcard.vue?vue&type=script&lang=ts"
export * from "./CopyFoodcard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports